<template lang="html">
  <div class="vx-col w-full">
    <vx-card title="Search Application">
      <template slot="actions">
        <vx-input-group class="">
          <vs-input class="w-full" placeholder="Enter Mobile or NID No"  v-model="searchParam" />
          <template slot="append">
            <div class="append-text btn-addon">
              <vs-button color="rgb(0 121 193)"  icon-pack="feather" icon="icon-search" @click="serachApplication(searchParam)"></vs-button>
            </div>
          </template>
        </vx-input-group>
      </template>
      <div id="data-list-list-view" class="data-list-container">
        <div v-if="$apollo.loading">
          <div :class="{'activeLoading':activeLoading}" id="loading-default"
               class="vs-con-loading__container loading-example"></div>
        </div>

        <vs-table
          :sst="true"
          @search="handleSearch"
          @change-page="handleChangePage"
          @sort="handleSort"
          v-model="selected"
          max-items="10000"
          :data="applicationList">
          <template slot="header">
            <!--<h3>
              Reviewed Application List
            </h3>-->
          </template>
          <template slot="thead">
            <vs-th sort-key="ID">
              ID
            </vs-th>
            <vs-th sort-key="email">
              Product Name
            </vs-th>
            <vs-th sort-key="username">
              Mobile No.
            </vs-th>
            <vs-th sort-key="website">
              Price Range
            </vs-th>
            <vs-th sort-key="id">
              Application Date
            </vs-th>
            <vs-th sort-key="id">
              Reprocess/Update Sales Doc
            </vs-th>
            <vs-th sort-key="id">
              Action
            </vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].id">
                {{paddingId(data[indextr].id)}}
              </vs-td>
              <vs-td :data="data[indextr].product">
                {{data[indextr].product.product}}
              </vs-td>

              <vs-td :data="data[indextr].user.phone">
                {{data[indextr].user.phone}}
              </vs-td>

              <vs-td :data="data[indextr].price_range">
                {{data[indextr].price_range}}
              </vs-td>
              <vs-td :data="data[indextr].accepting_date">
                {{data[indextr].accepting_date}}
              </vs-td>

              <vs-td :data="data[indextr].status">
                <!--<vs-chip :color="getOrderStatusColor(data[indextr].status)" class="product-order-status">
                  {{data[indextr].status =='7'?'Reviewed':'Accepted'}}
                </vs-chip>-->
                <vs-td class="whitespace-no-wrap">
                  {{data[indextr].invoice_number}}
                  <div v-if="!data[indextr].invoice_number" class="demo-alignment">
                    <!--<feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                  class="clickable"/>
                    <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                                  class="ml-2 clickable"/>-->
                    <vs-button color="success" class="mr-3 mt-0" @click="applicationDetal(data[indextr].id)">Reprocess</vs-button>
                    <vs-button color="success" class="mr-3 mt-0" @click="popupActive2=true, updateId=data[indextr].id, invoiceNumber = data[indextr].invoice_number">Update Sales Doc No</vs-button>

                  </div>
                </vs-td>
              </vs-td>
              <vs-td class="whitespace-no-wrap">
                <div class="demo-alignment">
                <!--<feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                              class="clickable"/>
                <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current"
                              class="ml-2 clickable"/>-->
                <feather-icon icon="EyeIcon" @click="applicationDetal(data[indextr].id)"
                              svgClasses="w-5 h-5 hover:text-success stroke-current"
                              class="ml-2 clickable"/>
                  <vx-tooltip text="Download Contract">
                <feather-icon icon="ArrowDownIcon" @click="downloadAgreement(data[indextr].id)"
                              svgClasses="w-5 h-5 hover:text-success stroke-current"
                              class="ml-2 clickable"/>
                  </vx-tooltip>
                </div>
              </vs-td>
            </vs-tr>
            <template>
              <div class="demo-alignment">
                <vs-popup classContent="popup-example" title="Update Sales Doc No" :active.sync="popupActive2">
                  <vx-card title="Sales Doc No">
                    <vs-input class="inputx" placeholder="New Sales Doc No" v-model="invoiceNumber"/>
                    <p class="text-danger text-sm">{{ invoiceMsg }}</p>
                    <p class="text-danger text-sm">{{ invoiceValidateMsg }}</p>
                    <div class="w-full text-right">
                      <vs-button :disabled="invoiceNumber==='' || !activeInvoice" @click="updateInvoice(updateId, invoiceNumber)" color="success" type="filled">Update Sales Doc No</vs-button>
                    </div>
                  </vx-card>
                </vs-popup>
              </div>
            </template>
          </template>
        </vs-table>
      </div>
    </vx-card>
  </div>
</template>
<script>
  import moduleDataList from '@/store/data-list/moduleDataList.js'
  import {ME} from '../../graphql/userinfo'
  import gql from 'graphql-tag'
  import addInvoice from '../../graphql/InvoiceAdd.gql'

  export default {
    data () {
      return {
        totalItems: 0,
        selected: [],
        selectedPgae: 1,
        itemsPerPage: 7,
        isMounted: false,
        pagination: '',
        userInfo: '',
        applicationList: [],
        // Data Sidebar
        addNewDataSidebar: false,
        sidebarData: {},
        activeLoading: false,
        searchParam:'',
        activeSearch:'',
        pdfFile:'',
        invoiceNumber:'',
        updateId:'',
        popupActive2: false,
        invoiceMsg:'',
        invoiceValidateMsg:'',
        activeInvoice : true
      }
    },
    apollo: {
      searchApplication: {
        query: gql`
        query searchApplication($keyword : String!){
          searchApplication(keyword: $keyword){
            id
            used_location
            location
            brand
            price_range
            status
            invoice_number
            accepting_date
            user{
              id
              phone
            }
            product{
                  id
                  product
                },
          }
         }
        `,
        variables () {
          // Use vue reactive properties here
          return {
            keyword: this.activeSearch
          }
        },
        update: (data) => data.searchApplication
      }
    },
    watch: {
      invoiceNumber(val){
        if(val){
          if(val[0] != 3){
            this.invoiceMsg = "Sales Doc no. must be start with 3"
            this.invoiceNumber = ''
          }
          if(val[0] == 3){
            this.invoiceMsg =''
          }
          if(val.length != 10){
            this.invoiceValidateMsg = "Sales Doc no. should be 10 digit."
            this.activeInvoice = false;
          }else {
            this.invoiceValidateMsg = "";
            this.activeInvoice = true;
          }
        }
      },
      searchApplication (value) {
        console.log('Me = ', value)
        this.applicationList = value;
        this.$apollo.queries.searchApplication.refetch()
      },
      '$apollo.loading': function (loading) {
        console.log('Loading', loading)
        if (loading === true) {
          this.$vs.loading({
            type: 'sound'
          })
        } else {
          this.$vs.loading.close()
        }
      }

    },
    computed: {
      currentPage () {
        if (this.isMounted) {
          return this.$refs.table.currentx
        }
        return 0
      },
      products () {
        //return this.$store.state.dataList.products
      },
      queriedItems () {
        return this.$refs.table ? this.$refs.table.queriedResults.length : this.products.length
      }
    },
    methods: {
      addNewData () {
        this.sidebarData = {}
        this.toggleDataSidebar(true)
      },
      deleteData (id) {
        this.$store.dispatch('dataList/removeItem', id).catch(err => {
          console.error(err)
        })
      },
      editData (data) {
        // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
        this.sidebarData = data
        this.toggleDataSidebar(true)
      },
      getOrderStatusColor (status) {
        if (status === 7) return 'primary'
        if (status === 5) return 'success'
        if (status === 'canceled') return 'danger'
        return 'primary'
      },
      getPopularityColor (num) {
        if (num > 90) return 'success'
        if (num > 70) return 'primary'
        if (num >= 50) return 'warning'
        if (num < 50) return 'danger'
        return 'primary'
      },
      toggleDataSidebar (val = false) {
        this.addNewDataSidebar = val
      },
      applicationDetal (applicationId) {
        this.$router.push('/applicationDetails/' + applicationId).catch(() => {
        })
      },
      handleSearch (searching) {
        let _print = `The user searched for: ${searching}\n`
        this.$refs.pre.appendChild(document.createTextNode(_print))
      },
      handleChangePage (page) {
        //let _print = `The user changed the page to: ${page}\n`
        this.selectedPgae = page
        this.$refs.pre.appendChild(document.createTextNode(_print))
      },
      handleSort (key, active) {
        let _print = `the user ordered: ${key} ${active}\n`
        this.$refs.pre.appendChild(document.createTextNode(_print))
      },
      serachApplication(data){
        this.activeSearch = this.searchParam;
        console.log("Search", this.activeSearch);
      },
      async updateInvoice (id, invoice) {
        console.log("ID=", id)
        console.log("invoice=", invoice)
        await this.$apollo.mutate({
          mutation: addInvoice,
          variables: {
            id: id,
            invoice_number: invoice
          }
        }).then((data) => {
          console.log('Data = ', data);
          this.$vs.notify({
            title: 'Save',
            text: 'Invoice Successfully Added.',
            color: "success",
            position: 'top-right'
          })
          this.popupActive2= false
        }).catch((error) => {
          this.$vs.notify({
            title: 'Error!',
            text: 'Something went wrong.',
            color: "danger",
            position: 'top-right'
          })
          this.popupActive2= false
        })
      },
      paddingId(id){
        console.log("--------->",id.toString().length);
        if(id.toString().length === 1){return 'A000000000'+id;}
        else if(id.toString().length === 2){return 'A00000000'+id;}
        else if(id.toString().length === 3){return 'A0000000'+id;}
        else if(id.toString().length === 4){return 'A000000'+id;}
        else if(id.toString().length === 5){return 'A00000'+id;}
        else if(id.toString().length === 6){return 'A0000'+id;}
        else if(id.toString().length === 7){return 'A000'+id;}
        else if(id.toString().length === 8){return 'A00'+id;}
        else if(id.toString().length === 9){return 'A'+id;}
        else if(id.toString().length === 10){return id;}

      },
      downloadAgreement(id){
        this.pdfFile =  "https://showroom.butterflygroupbd.com/showroom-backend/storage/agreement_"+id+".pdf";
        return window.open(this.pdfFile);
      }
    },
    created () {
      if (!moduleDataList.isRegistered) {
        this.$store.registerModule('dataList', moduleDataList)
        moduleDataList.isRegistered = true
      }
      this.$store.dispatch('dataList/fetchDataListItems')
    },
    mounted () {
      this.isMounted = true
    }
  }
</script>

<style lang="scss">
  .clickable {
    cursor: pointer;
  }

  img.product-img.butterfly-product {
    height: 40px;
    width: auto;
  }

  .vs-table--not-data {
    display: none;
  }

  #data-list-list-view {
    .vs-con-table {

      /*
        Below media-queries is fix for responsiveness of action buttons
        Note: If you change action buttons or layout of this page, Please remove below style
      */
      @media (max-width: 689px) {
        .vs-table--search {
          margin-left: 0;
          max-width: unset;
          width: 100%;

          .vs-table--search-input {
            width: 100%;
          }
        }
      }

      @media (max-width: 461px) {
        .items-per-page-handler {
          display: none;
        }
      }

      @media (max-width: 341px) {
        .data-list-btn-container {
          width: 100%;

          .dd-actions,
          .btn-add-new {
            width: 100%;
            margin-right: 0 !important;
          }
        }
      }

      .product-name {
        max-width: 23rem;
      }

      .vs-table--header {
        display: flex;
        flex-wrap: wrap;
        margin-left: 1.5rem;
        margin-right: 1.5rem;

        > span {
          display: flex;
          flex-grow: 1;
        }

        .vs-table--search {
          padding-top: 0;

          .vs-table--search-input {
            padding: 0.9rem 2.5rem;
            font-size: 1rem;

            & + i {
              left: 1rem;
            }

            &:focus + i {
              left: 1rem;
            }
          }
        }
      }

      .vs-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        padding: 0 1rem;

        tr {
          box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

          td {
            padding: 20px;

            &:first-child {
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }

            &:last-child {
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }

          td.td-check {
            padding: 20px !important;
          }
        }
      }

      .vs-table--thead {
        th {
          padding-top: 0;
          padding-bottom: 0;

          .vs-table-text {
            text-transform: uppercase;
            font-weight: 600;
          }
        }

        th.td-check {
          padding: 0 15px !important;
        }

        tr {
          background: none;
          box-shadow: none;
        }
      }

      .vs-table--pagination {
        justify-content: center;
      }
    }
  }


  .fill-row-loading {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;

    .loading-example {
      width: 120px;
      float: left;
      height: 120px;
      box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.05);
      border-radius: 10px;
      margin: 8px;
      transition: all 0.3s ease;
      cursor: pointer;

      &:hover {
        box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.05);
        transform: translate(0, 4px);
      }

      h4 {
        z-index: 40000;
        position: relative;
        text-align: center;
        padding: 10px;
      }

      &.activeLoading {
        opacity: 0 !important;
        transform: scale(0.5);
      }
    }
  }


</style>
